// extracted by mini-css-extract-plugin
export default {"pricing":"PricingContent_pricing__3ZAc-","toggle":"PricingContent_toggle__4iupt","toggleBtn":"PricingContent_toggleBtn__CkKBB","active":"PricingContent_active__XZn1X"};